/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
  TextInput,
  headingTypes,
} from '../coreui';

const HeroTextInput = ({
  placeholder,
  value,
  onChange,
  onKeyDown,
  ...additionalProps
}) => {
  return (
    <TextInput
      {...headingTypes.H7}
      borderRadius={0}
      w={[250, null, 400, null, 600]}
      boxSizing="border-box"
      px={20}
      py={[15, null, null, 17, 24]}
      height={[45, null, 49, null, 66]}
      bg="rgba(255, 255, 255, 0.85)"
      mr={[null, null, null, 20]}
      mb={[20, null, null, 0]}
      border="0 none"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      {...additionalProps}
    />
  );
};

HeroTextInput.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
};

HeroTextInput.defaultProps = {
  placeholder: null,
};

export default HeroTextInput;
